import { type ItemId } from '@/infra/services/catalog/model.d';
import { useSellers } from '@/presenters/hooks/catalog';
import { useProductStore } from '@/presenters/store/catalog/product';

const useSellersOptions = (itemId: ItemId) => {
  const { data: sellers, isFetching } = useSellers(itemId);

  const currentSeller = useProductStore((store) => store.currentSeller);
  const setCurrentSeller = useProductStore((store) => store.setCurrentSeller);

  const handleSellerChange = (value: string) => {
    const currentSeller = sellers?.find((seller) => seller.id === value);

    if (currentSeller) {
      setCurrentSeller(currentSeller);
    }
  };

  return { currentSeller, handleSellerChange, sellers, isFetching };
};

export default useSellersOptions;
